import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Input,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CalendarIcon, FilterIconDark } from "../../assets/icons/icons";
import SelectTagsComponent from "./uploads/SelectTagsComponent";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useGetAdminAndSupers } from "../settings/hooks";
import { useGetProjectImages } from "./uploads/hooks";
import { StandaloneSearchBox } from "@react-google-maps/api";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const FilterPhotos = ({ setImages, setIsFetching }: any) => {
  const { id } = useParams();

  const theme = useTheme();

  const [isOpenAddModal, setIsOpenAddModal] = useState(false);
  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");
  const [matchAllTags, setMatchAllTags] = useState(false);
  const [tags, setTags] = useState([]);
  const [tagsCompKey, setTagsCompKey] = useState(1);
  const [dateType, setDateType] = useState("date_taken");
  const [date, setDate] = useState(null);
  const [photoType, setPhotoType] = useState("");
  const [references, setReferences] = useState([]);
  const [uploadedBy, setUploadedBy] = useState([]);
  const { data: accountUsers, isFetching: isFetchingUsers } =
    useGetAdminAndSupers("users");
  const [obj, setObj] = useState({});

  const {
    data: images,
    isLoading: isFetching,
    refetch,
  } = useGetProjectImages("projectphotos", id, obj);

  const handleClose = () => {
    setObj({
      title,
      location,
      dateType,
      date,
      tags: (tags as string[]).map((tag) => tag.trim()),
      matchAllTags,
      photoType,
      references,
      uploadedBy,
    });
    setIsOpenAddModal(false);
  };

  // Check if there is any filter
  const hasFilter = () => {
    return (
      title != "" ||
      location != "" ||
      tags.length > 0 ||
      date != null ||
      photoType != "" ||
      references.length > 0 ||
      uploadedBy.length > 0
    );
  };

  // Reset filters
  const resetFilters = () => {
    setTitle("");
    setLocation("");
    setTags([]);
    setMatchAllTags(false);
    setTagsCompKey(Math.floor(Math.random() * 1000));
    setDate(null);
    setPhotoType("");
    setReferences([]);
    setUploadedBy([]);
  };

  useEffect(() => {
    if (images != undefined) setImages(images);
  }, [images]);

  return (
    <Box sx={{ position: "relative" }}>
      <Button
        variant="contained"
        sx={{
          padding: theme.spacing(1.5, 3, 1.5, 3),
          borderRadius: "8px",
          textTransform: "capitalize",
          width: 140,
          fontSize: "13px",
          backgroundColor: isOpenAddModal ? "white" : "rgba(36, 33, 44, 0.08)",
          boxShadow: "none",
          color: "#24212C",
          zIndex: isOpenAddModal ? 999999 : 1,
          "&:hover": {
            boxShadow: "none",
            backgroundColor: isOpenAddModal
              ? "white"
              : "rgba(36, 33, 44, 0.08)",
          },
        }}
        onClick={() => {
          setIsOpenAddModal(true);
        }}
      >
        <FilterIconDark /> <Box sx={{ width: 10 }} /> Filter
        {hasFilter() && (
          <Box
            sx={{
              backgroundColor: "#F0845D",
              width: "8px",
              height: "8px",
              position: "absolute",
              right: 28,
              top: 11,
              borderRadius: 99,
            }}
          />
        )}
      </Button>
      {isOpenAddModal && (
        <Box
          sx={{
            // position: 'absolute',
            backgroundColor: "red",
          }}
          // open={isOpenAddModal}
          // onClose={handleClose}
          // aria-labelledby="modal-modal-title"
          // aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              backgroundColor: "rgba(0,0,0,0.1)",
              width: "100vw",
              height: "100vh",
              position: "fixed",
              top: 0,
              left: 0,
              zIndex: 79,
            }}
            onClick={() => {
              setIsOpenAddModal(false);
              handleClose();
            }}
          />
          <Box
            sx={{
              ...style,
              zIndex: 79,
              width: 650,
              maxHeight: "95vh",
              overflow: "scroll",
              "::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <Box
              display="flex"
              alignItems={"center"}
              justifyContent={"space-between"}
              marginBottom="12px"
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Typography
                  sx={{ fontSize: 20, fontWeight: "600", fontFamily: "Rza" }}
                >
                  Filter Photos
                </Typography>
                {hasFilter() && (
                  <>
                    <Box
                      sx={{
                        width: "1px",
                        height: 25,
                        backgroundColor: "#DBDBDB",
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: 14,
                        color: "#5A525B",
                        cursor: "pointer",
                      }}
                      onClick={() => resetFilters()}
                    >
                      Clear Filters
                    </Typography>
                  </>
                )}
              </Box>
              <IconButton onClick={() => handleClose()}>
                <Close />
              </IconButton>
            </Box>
            <Grid
              container
              sx={{
                width: "100%",
              }}
              // marginBottom={4}
              spacing={2}
            >
              <Grid item xs={6}>
                <Typography
                  fontSize={"14px"}
                  color="#5A525B"
                  paddingBottom={0.5}
                  fontWeight="bold"
                >
                  Title
                </Typography>
                <Box
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "8px",
                    border: "1px solid #DBDBDB",
                    padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                  }}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Input
                    disableUnderline
                    sx={{
                      width: "100%",
                      fontSize: "17px",
                      "& input::placeholder": {
                        fontWeight: "bold",
                      },
                    }}
                    type="text"
                    fullWidth={true}
                    onChange={(e: any) => setTitle(e.target.value)}
                    value={title}
                    required={true}
                    disabled={false}
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"14px"}
                  color="#5A525B"
                  paddingBottom={0.5}
                  fontWeight="bold"
                >
                  Location
                </Typography>
                <StandaloneSearchBox                  >
                  <Box
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "8px",
                      border: "1px solid #DBDBDB",
                      padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                    }}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <Input
                      disableUnderline
                      sx={{
                        width: "100%",
                        fontSize: "17px",
                      }}
                      placeholder={"Enter Location"}
                      name={`searchbox`}
                      type="text"
                      fullWidth={true}
                      value={location}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setLocation(e.target.value)
                      }
                      required={true}
                    />
                  </Box>
                </StandaloneSearchBox>
              </Grid>
              <Grid item xs={6}>
                <RadioGroup
                  aria-labelledby={`automaticClockOut_label`}
                  defaultValue=""
                  value={dateType}
                  name={"automaticClockOutEnabled"}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    flexDirection: "row",
                  }}
                  onChange={(e: any) => {
                    setDateType(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value={"date_taken"}
                    control={<Radio />}
                    label={"Date taken"}
                  />
                  <FormControlLabel
                    value={"date_added"}
                    control={<Radio />}
                    label={"Date added"}
                  />
                </RadioGroup>
                <Box
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "8px",
                    border: "1px solid #DBDBDB",
                    marginTop: 1.5,
                    padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                    zIndex: "88",
                  }}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={date}
                      onChange={(e: any) => setDate(e)}
                      renderInput={(params: any) => {
                        return (
                          <TextField
                            {...params}
                            variant="standard"
                            name="projectDueDate"
                            label=""
                            required
                            InputProps={{
                              ...params?.InputProps,
                              endAdornment: (
                                // @ts-ignore
                                <IconButton
                                  {...params?.InputProps}
                                  onClick={(event) => {
                                    // @ts-ignore
                                    params?.InputProps?.endAdornment?.props?.children?.props?.onClick();
                                  }}
                                >
                                  <CalendarIcon />
                                </IconButton>
                              ),
                            }}
                            sx={{
                              width: "100%",
                              "& .MuiInput-underline:before": {
                                display: "none",
                              },
                              "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                {
                                  display: "none",
                                },
                              "& .MuiInput-underline:after": {
                                display: "none",
                              },
                            }}
                          />
                        );
                      }}
                    />
                  </LocalizationProvider>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"14px"}
                  color="#5A525B"
                  paddingBottom={0.5}
                  fontWeight="bold"
                >
                  Tags
                </Typography>
                <SelectTagsComponent
                  key={tagsCompKey}
                  isFullWidth={false}
                  tags={tags}
                  setTags={setTags}
                />
                <FormControlLabel
                  label="Results must include all tags"
                  sx={{
                    "& span": {
                      fontSize: 16,
                    },
                  }}
                  control={
                    <Checkbox
                      checked={matchAllTags}
                      onChange={(e: any) => setMatchAllTags(e.target.checked)}
                    />
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"14px"}
                  color="#5A525B"
                  paddingBottom={0.5}
                  fontWeight="bold"
                >
                  Photo Type
                </Typography>
                <Box
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "8px",
                    border: "1px solid #DBDBDB",
                  }}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Select
                    labelId="demo-controlled-open-select-label"
                    id="demo-controlled-open-select"
                    value={photoType}
                    sx={{
                      width: "100%",
                      border: "none",
                      boxShadow: "none",
                      padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                      "& .MuiSelect-select": {
                        padding: theme.spacing(0.8, 0, 0.8, 0),
                      },
                      "&:hover, & fieldset, & fieldset:hover": {
                        border: "none",
                        // padding: 0,
                        margin: 0,
                        boxShadow: "none",
                      },
                    }}
                    onChange={(e: any) => setPhotoType(e.target.value)}
                  >
                    {[
                      { label: "PNG", value: "png" },
                      { label: "JPEG", value: "jpeg" },
                      { label: "JPG", value: "jpg" },
                      { label: "HEIC", value: "heic" },
                      { label: "GIF", value: "gif" },
                      { label: "TIFF", value: "tiff" },
                      { label: "BMP", value: "bmp" },
                      { label: "WebP", value: "webp" },
                      { label: "SVG", value: "svg" },
                    ].map((option: any, key: any) => (
                      <MenuItem key={key} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"14px"}
                  color="#5A525B"
                  paddingBottom={0.5}
                  fontWeight="bold"
                >
                  Referenced by
                </Typography>
                <Box
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "8px",
                    border: "1px solid #DBDBDB",
                  }}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Select
                    labelId="demo-controlled-open-select-label"
                    id="demo-controlled-open-select"
                    value={references}
                    name="superintendents"
                    required
                    multiple
                    sx={{
                      width: "100%",
                      border: "none",
                      boxShadow: "none",
                      padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                      "& .MuiSelect-select": {
                        padding: theme.spacing(0.8, 0, 0.8, 0),
                      },
                      "&:hover, & fieldset, & fieldset:hover": {
                        border: "none",
                        // padding: 0,
                        margin: 0,
                        boxShadow: "none",
                      },
                    }}
                    renderValue={(selected: any) => {
                      return selected
                        .map((item: any) => {
                          return (
                            accountUsers?.find((e: any) => e._id == item)
                              ?.firstName +
                            " " +
                            accountUsers?.find((e: any) => e._id == item)
                              ?.lastName
                          );
                        })
                        .join(", ");
                    }}
                    // @ts-ignore
                    onChange={(
                      event?: React.ChangeEvent<HTMLSelectElement> | any
                    ) => {
                      const selectedOptions = event.target.value;
                      setReferences(selectedOptions);
                    }}
                  >
                    {accountUsers?.map((user: any, key: any) => {
                      return (
                        <MenuItem key={key} value={user._id}>
                          <Checkbox
                            checked={
                              references?.findIndex((e: any) => e == user._id) >
                              -1
                            }
                          />
                          {user.firstName + " " + user.lastName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"14px"}
                  color="#5A525B"
                  paddingBottom={0.5}
                  fontWeight="bold"
                >
                  Uploaded by
                </Typography>
                <Box
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "8px",
                    border: "1px solid #DBDBDB",
                  }}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Select
                    labelId="demo-controlled-open-select-label"
                    id="demo-controlled-open-select"
                    value={uploadedBy}
                    name="superintendents"
                    required
                    multiple
                    sx={{
                      width: "100%",
                      border: "none",
                      boxShadow: "none",
                      padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                      "& .MuiSelect-select": {
                        padding: theme.spacing(0.8, 0, 0.8, 0),
                      },
                      "&:hover, & fieldset, & fieldset:hover": {
                        border: "none",
                        // padding: 0,
                        margin: 0,
                        boxShadow: "none",
                      },
                    }}
                    renderValue={(selected: any) => {
                      return selected
                        .map((item: any) => {
                          return (
                            accountUsers?.find((e: any) => e._id == item)
                              ?.firstName +
                            " " +
                            accountUsers?.find((e: any) => e._id == item)
                              ?.lastName
                          );
                        })
                        .join(", ");
                    }}
                    // @ts-ignore
                    onChange={(
                      event?: React.ChangeEvent<HTMLSelectElement> | any
                    ) => {
                      const selectedOptions = event.target.value;
                      setUploadedBy(selectedOptions);
                    }}
                  >
                    {accountUsers?.map((user: any, key: any) => {
                      return (
                        <MenuItem key={key} value={user._id}>
                          <Checkbox
                            checked={
                              uploadedBy?.findIndex((e: any) => e == user._id) >
                              -1
                            }
                          />
                          {user.firstName + " " + user.lastName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Box>
              </Grid>
            </Grid>
            {/* <Button
              variant="contained"
              sx={{
                padding: theme.spacing(1.5, 3, 1.5, 3),
                borderRadius: "8px",
                textTransform: "capitalize",
                width: "100%",
                fontSize: "13px",
                whiteSpace: "nowrap",
                color: "white !important",
                boxShadow: "none",
                "&:hover": {
                  boxShadow: "none",
                },
              }}
              onClick={() => {}}
            >
              <Box sx={{ width: 10 }} /> Filter
            </Button> */}
          </Box>
        </Box>
      )}
    </Box>
  );
};
const style = {
  position: "absolute" as "absolute",
  top: 60,
  right: 0,
  // top: "50%",
  // left: "50%",
  // transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "1px solid #CCCCCC",
  borderRadius: "22px",
  boxShadow: `
    0px 4px 10px 0px rgba(36, 33, 44, 0.05),
    0px 18px 18px 0px rgba(36, 33, 44, 0.04),
    0px 40px 24px 0px rgba(36, 33, 44, 0.03),
    0px 71px 29px 0px rgba(36, 33, 44, 0.03),
    0px 111px 31px 0px rgba(36, 33, 44, 0.00)
  `,
  p: 3,
  overlay: {
    background: "#FFFF00",
  },
};
